import React from 'react'
import {
  Box,
  FormControlLabel,
  type FormControlLabelProps,
  Switch as MuiSwitch,
  type SwitchProps as MuiSwitchProps,
  type SxProps,
  Typography,
} from '@mui/material'

export interface SwitchProps extends MuiSwitchProps {
  label?: string
  labelPlacement?: FormControlLabelProps['labelPlacement']
  description?: string
  containerSx?: SxProps
  containerClassName?: string
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (
    {
      label,
      labelPlacement = 'end',
      description,
      containerSx,
      containerClassName,
      disabled,
      ...props
    },
    ref,
  ) => {
    const switchElement = <MuiSwitch ref={ref} disabled={disabled} {...props} />

    if (!label && !description) {
      return switchElement
    }

    if (description) {
      return (
        <Box
          className={containerClassName}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            ...containerSx,
          }}
        >
          <Box>
            {label && <Typography variant='subtitle1'>{label}</Typography>}
            <Typography
              variant='body2'
              sx={{
                color: 'text.secondary',
              }}
            >
              {description}
            </Typography>
          </Box>
          {switchElement}
        </Box>
      )
    }

    return (
      <FormControlLabel
        control={switchElement}
        label={label}
        labelPlacement={labelPlacement}
        disabled={disabled}
        className={containerClassName}
        sx={{
          ...(labelPlacement === 'start' && {
            justifyContent: 'space-between',
          }),
          ...containerSx,
        }}
      />
    )
  },
)

Switch.displayName = 'Switch'

export default Switch
